import { computed, Injectable, signal } from '@angular/core';
import { Item } from '@models/item.interface';
import { Raffle, RaffleRoll } from '@models/raffle.interface';
// import { RaffleRollData, RaffleStats, RaffleTickets, RaffleUpdate } from '@models/raffle.interface';
import { SocketService } from '@shared/socket.service';

@Injectable({
  providedIn: 'root',
})
export class RafflesService {
  // raffleStats = signal<RaffleStats>({ total_wagered: 0, tickets: [] });
  // tickets = signal<RaffleTickets>({ tickets: [], total: 0 });
  // updateRafflesData = signal<RaffleUpdate>({ prizes: [], random: [], ends: 0 });
  // raffleRollData = signal<RaffleRollData | null>(null);
  rafflesRoot = signal<Raffle>({
    ends: 0,
    players: [],
    rewards: [],
  });
  rafflesRoll = signal<RaffleRoll | null>(null);
  isEndRoll = signal(false);

  readonly rewards = computed<Item[]>(() => {
    const rootData = this.rafflesRoot();
    // if (rootData && rootData.rewards) {
    //   return this.transformRewardsWithAssetId(rootData.rewards);
    // }
    return rootData.rewards ?? [];
  });

  constructor(private socketService: SocketService) {
    this.socketService.socket.on('update_giveaway_page', (data: Raffle[]) => {
      // An empty array would set `undefined` and make the `rewards` computed dereference it.
      if (Array.isArray(data) && data.length > 0) {
        this.rafflesRoot.set(data[0]);
      }
    });

    // No `get_giveaway_page` pull: the BE sends `update_giveaway_page` in its connect-time
    // push, so asking for it only spent one of the few requests that window allows.
    // tf2-hunt dropped the same call for the same reason (giveaways.service.ts).

    this.socketService.socket.on('giveaway_roll', (data: RaffleRoll) => {
      this.rafflesRoll.set(data);
    });
  }

  // transformRewardsWithAssetId(rewards: RaffleReward[]): Item[] {
  //   return rewards.map((reward) => ({
  //     ...reward,
  //     assetid: String(uuidv4()),
  //   }));
  // }
}
